import { defineMessages } from "react-intl";

export const messages = defineMessages({
  title: {
    id: "UQu75k",
    defaultMessage: "Approve this fulfillment",
    description: "dialog header",
  },
  description: {
    id: "EHsnZX",
    defaultMessage: "Are you sure you want to approve this fullfillment?",
    description: "dialog description",
  },
  notifyCustomer: {
    id: "SqhC7g",
    defaultMessage: "Send shipment details to customer",
    description: "checkbox label, fulfillment approval",
  },
});
